// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XqufdZNoDbQUG9SyKF7K{align-items:flex-end;display:flex;flex-grow:1;justify-content:space-evenly;max-height:16px}.OhB_7Ncqm7kTs0CXJeUs{font-size:30px}.TGrL8Pw8pAVcYoBaNXoE{font-size:16px}.DSLPO7or00PgAeDyfO3S.DSLPO7or00PgAeDyfO3S.DSLPO7or00PgAeDyfO3S{font-weight:500;line-height:16px;margin-bottom:0;min-width:55px;text-align:center}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"clockCounterContainer": `XqufdZNoDbQUG9SyKF7K`,
	"clockCounterContainerDesktop": `OhB_7Ncqm7kTs0CXJeUs`,
	"clockCounterContainerMobile": `TGrL8Pw8pAVcYoBaNXoE`,
	"clockNumber": `DSLPO7or00PgAeDyfO3S`
};
export default ___CSS_LOADER_EXPORT___;
